export default __webpack_public_path__ + "static/media/dependents-glyph-16px.96c51a23.svg";